import React from "react"
import GetNotifications from "../containers/GetNotifications"

const EventAlerts = ({ handleSubmit }) => (
  <GetNotifications type="event" onSubmit={handleSubmit} />
)

export default EventAlerts
